// src/sections/NetzwerkRouterSection.jsx
import { useState, useEffect } from "react";
import { Box, Heading, Grid, Input, Button, VStack } from "@chakra-ui/react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";

export default function NetzwerkRouterSection({ selectedAnlageId }) {
  const [router, setRouter] = useState({
    hersteller: "",
    ipAdresse: "",
    netzwerk: "",
    subnetmaske: "",
  });
  const [herstellerList, setHerstellerList] = useState([]);


  // ✅ LOAD existing data
  useEffect(() => {
    if (!selectedAnlageId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/netzwerkrouter/anlage/${selectedAnlageId}`)
      .then((res) => {
        if (res.data) setRouter(res.data);
      })
      .catch(() => {
        setRouter({ hersteller: "", ipAdresse: "", netzwerk: "", subnetmaske: "" });
      });
  }, [selectedAnlageId]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/hersteller`)
      .then((res) => setHerstellerList(res.data))
      .catch((err) => console.error("Error loading Hersteller:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRouter((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      if (router.id) {
        await axios.put(`${process.env.REACT_APP_API_URL}/api/netzwerkrouter/${router.id}`, {
          ...router,
          anlage: { id: selectedAnlageId },
        });
        showSuccess("Erfolg!", "Netzwerk-Router aktualisiert.");
      } else {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/netzwerkrouter`, {
          ...router,
          anlage: { id: selectedAnlageId },
        });
        setRouter(res.data); // ✅ Save router with ID for future updates
        showSuccess("Erfolg!", "Netzwerk-Router gespeichert.");
      }
    } catch {
      showError("Fehler!", "Speichern fehlgeschlagen.");
    }
  };

  return (
        <Box 
      p={8} 
      bg="white" 
      borderRadius="xl" 
      boxShadow="md" 
      mt={6} 
      mb={10} 
      maxW="fit-content"
    >
      <Heading fontSize="21px" mb={6} color="black.600">
        NETZWERK-ROUTER
      </Heading>

      <VStack spacing={4} align="stretch" bg="gray.50" p={4} rounded="lg">
        <Grid templateColumns="repeat(4, 1fr)" gap={4}>
          <select name="hersteller" value={router.hersteller} onChange={handleChange}>
            <option value="">Hersteller wählen</option>
            {herstellerList.map((h) => (
              <option key={h.id} value={h.name}>
                {h.name}
              </option>
            ))}
          </select>

          <Input
            name="ipAdresse"
            placeholder="IP-Adresse"
            value={router.ipAdresse}
            onChange={handleChange}
          />
          <Input
            name="netzwerk"
            placeholder="Netzwerk"
            value={router.netzwerk}
            onChange={handleChange}
          />
          <Input
            name="subnetmaske"
            placeholder="Subnetmaske"
            value={router.subnetmaske}
            onChange={handleChange}
          />
        </Grid>

        <Button 
         bg="#B8860B"
         _hover={{ bg: "#C99414" }}
        size="lg"
        width="fit-content" 
        onClick={handleSave}>
          Speichern Netzwerk-Router
        </Button>

        {router.id && (
          <Button
            bg="#B22222" // Firebrick red (similar depth to your gold)
              color="white"
              _hover={{ bg: "#D22B2B" }} // Slightly lighter red on hover
              size="md"
              width="fit-content"
            onClick={async () => {
              await axios.delete(`${process.env.REACT_APP_API_URL}/api/netzwerkrouter/${router.id}`);
              setRouter({ hersteller: "", ipAdresse: "", netzwerk: "", subnetmaske: "" });
              showSuccess("Gelöscht!", "Netzwerk-Router gelöscht.");
            }}
          >
            Löschen
          </Button>
        )}

      </VStack>
    </Box>
  );
}